var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_163_1029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8749 10.2919C11.4371 10.2919 11.0833 10.6466 11.0833 11.0835V14.2502C11.0833 14.6864 10.7286 15.0418 10.2915 15.0418H7.91654V3.16695C7.91654 2.49087 7.48587 1.88684 6.83835 1.66201L6.60395 1.58359H10.2915C10.7286 1.58359 11.0833 1.93902 11.0833 2.37534V4.75032C11.0833 5.18722 11.4371 5.54193 11.8749 5.54193C12.3126 5.54193 12.6665 5.18722 12.6665 4.75032V2.37534C12.6665 1.06594 11.6009 0.000366211 10.2915 0.000366211H1.78123C1.75108 0.000366211 1.72586 0.0138472 1.69658 0.017761C1.65845 0.014572 1.62207 0.000366211 1.58337 0.000366211C0.710144 0.000366211 0 0.710365 0 1.58359V15.8334C0 16.5095 0.430667 17.1136 1.07819 17.3384L5.84249 18.9265C6.00397 18.9764 6.16459 19.0002 6.33332 19.0002C7.20654 19.0002 7.91654 18.29 7.91654 17.4168V16.6252H10.2915C11.6009 16.6252 12.6665 15.5596 12.6665 14.2502V11.0835C12.6665 10.6466 12.3126 10.2919 11.8749 10.2919Z",
    fill: "#111F3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7679 7.3571L15.6011 4.19051C15.3749 3.96409 15.0344 3.89596 14.7383 4.0186C14.4431 4.14137 14.2498 4.43027 14.2498 4.75019V7.12517H11.0833C10.6462 7.12517 10.2915 7.47973 10.2915 7.91678C10.2915 8.35382 10.6462 8.70839 11.0833 8.70839H14.2498V11.0834C14.2498 11.4033 14.4431 11.6922 14.7383 11.815C15.0344 11.9376 15.3749 11.8695 15.6011 11.6432L18.7679 8.47646C19.0773 8.16697 19.0773 7.66658 18.7679 7.3571Z",
    fill: "#111F3E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_163_1029"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitIcon);
export default __webpack_public_path__ + "static/media/exitIcon.119ac22cca696594ada551e74a5c7f3c.svg";
export { ForwardRef as ReactComponent };